import React, { useEffect, useState } from "react";
import './MenuFrontal.scss'
import menuDataJson from '../../../assets/jsons/FrontMenuData.json'
import MenuItem from "./MenuItem";
import iconLogOut from '../../../assets/icons/logout.svg'
import { encriptar } from "../../../utilities/encriptacion";
import { useNavigate } from "react-router-dom";
import useGetScreenSize from "../../../CustomHooks/useGetScreenSize";
import MenuCompletoMovil from "./MenuCompletoMovil";
import { getDb, getPermisos } from "./menuFrontalIntegracion";
import { jwtDecode } from "jwt-decode";
const key = process.env.REACT_APP_CLAVE_INCRIPTACION;

const MenuFrontal = ({ children }) => {
    const navigate = useNavigate()
    const [openMenuIndex, setOpenMenuIndex] = useState(null);
    const [token, setToken] = useState(null);
    const [db, setDb] = useState(null);
    const [menuFiltradoPorPermisos, setMenuFiltradoPorPermisos] = useState(null);

    const desLoguear = () => {
        const auth = encriptar("false", key);
        sessionStorage.setItem("authMonitor", auth);
        sessionStorage.setItem("token", "");
        navigate("/")
        window.location.reload();
    }
    const tamañoPantalla = useGetScreenSize()
    useEffect(() => {
        getPermisos(setMenuFiltradoPorPermisos, menuDataJson)
        getDb(setDb)
        const tokenDecript = jwtDecode(sessionStorage.getItem("token"))

        setToken(tokenDecript)
        if (window.location.pathname.includes('/monitoreo/solicitud-reembolso/')) {
            document.getElementById('menu').style.display = "none"
            document.getElementById('MenuFrontal').style.display = "flex"
            document.getElementById('MenuFrontal').style.justifyContent = "center"
        }

    }, [])
    const handleDownload = (url, fileName) => {
        const link = document.createElement("a");
        link.href = url;
        link.download = fileName; // 👈 fuerza el nombre de descarga
        link.target = "_blank";   // abre en nueva pestaña si el navegador no soporta download
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <div className="MenuFrontal" id="MenuFrontal">
            <div className="menu" id="menu">
                {
                    tamañoPantalla.width > 1023 ?
                        <>
                            {

                                menuFiltradoPorPermisos?.map((item, key) => {
                                    return (
                                        <>
                                            <MenuItem menuData={item} index={key} setOpenMenuIndex={setOpenMenuIndex} openMenuIndex={openMenuIndex} ></MenuItem>
                                        </>
                                    )

                                })
                            }
                        </> :
                        <>
                            {
                                <MenuCompletoMovil menuData={menuFiltradoPorPermisos} setOpenMenuIndex={setOpenMenuIndex} openMenuIndex={openMenuIndex}></MenuCompletoMovil>
                            }
                        </>
                }
                <div className="containerHeader">
                    {
                        db == 'SUMA_TESTING' ?
                            <>
                                <div className="nombreContainer">
                                    <div className="base-de-datos" onClick={() => { navigate("/") }}>{db}</div>
                                </div>
                            </> : ""
                    }
                    {
                        tamañoPantalla.width > 1023 ?
                            <div className="nombreContainer">
                                <div className="nombre" onClick={() => { navigate("/") }}>{token?.NOMBRE}</div>
                            </div> : ""

                    }
                    {/* boton para descargar manual con icono*/}
                    <div className="manualContainer">
                        <div className="manual" onClick={() => handleDownload('https://repo.sumaenlinea.mx/manuales/ManualdeMonitorSUMAv5.1.pdf', 'Manual Monitor')}>{tamañoPantalla.width > 1023 ? "Descargar Manual" : "Manual"}</div>

                    </div>
                    <div className="iconoSalir">
                        <img src={iconLogOut} onClick={() => { desLoguear() }}></img>
                    </div>
                </div>

            </div>
            <div className="contenido-global" id="scrollable-content">{children}</div>
        </div>
    )
}
export default MenuFrontal